export const SET_NEW_DATA = 'SET_NEW_DATA';
export const SET_SEARCH_MAP_INSTANCE = 'SET_SEARCH_MAP_INSTANCE';
export const SET_ZOOM = 'SET_ZOOM';

export const setNewData = ({data, params}) => {
    return {
        type: SET_NEW_DATA,
        payload: {
            data,
            params
        }
    };
};

export const setSearchMapInstance = searchMapInstance => {
    return {
        type: SET_SEARCH_MAP_INSTANCE,
        payload: {
            searchMapInstance
        }
    };
};

export const setZoom = zoom => {
    return {
        type: SET_ZOOM,
        payload: {
            zoom
        }
    };
};



// WEBPACK FOOTER //
// ./widget/src/js/common/search-actions.js